import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        home: false,
        footer: false,
    },
    mutations: {
        toggleHome (state) {
            state.home = !state.home;
        },
        homeTrue (state) {
            state.home = true;
        },
        homeFalse (state) {
            state.home = false;
        },
        toggleFooter (state) {
            state.footer = !state.footer;
        },
        footerTrue (state) {
            state.footer = true;
        },
        footerFalse (state) {
            state.footer = false;
        }
    },
    actions: {
        toggleHome (store) {
            store.commit({
                type: 'toggleHome'
            })
        },
        homeTrue (store) {
            store.commit({
                type: 'homeTrue'
            })
        },
        homeFalse (store) {
            store.commit({
                type: 'homeFalse'
            })
        },
        toggleFooter (store) {
            store.commit({
                type: 'toggleFooter'
            })
        },
        footerTrue (store) {
            store.commit({
                type: 'footerTrue'
            })
        },
        footerFalse (store) {
            store.commit({
                type: 'footerFalse'
            })
        }
    },
    getters: {
        home (state) {
            return state.home
        },
        footer (state) {
            return state.footer
        }
    }
        
})
